import { createSlice } from '@reduxjs/toolkit';
import { jobsConstants, userConstants } from '../_constants';

const initialState = {
  jobs: [],
  showForm: false,
  jobsRequest: [],
  detailJob: null,
  filters: {},
  companies: [],
  companyDetail: null,
  companyDetailJobs: [],
  applicants: [],
  applications: [],
  detailApplicant: null,
  isLoading: false,
  error: null,
  success: false,
};

const jobsSlice = createSlice({
  name: 'jobsForm',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(jobsConstants.UPDATE_LOADING, (state, action) => {
        state.isLoading = action.payload;
      })
      .addCase(jobsConstants.UPDATE_ERROR, (state, action) => {
        state.error = action.payload;
      })
      .addCase(
        jobsConstants.UPDATE_REQUEST_DETAIL_APPLICANT_JOBS,
        (state, action) => {
          state.detailApplicant = action.payload;
        }
      )
      .addCase(jobsConstants.UPDATE_FILTERS, (state, action) => {
        state.filters = action.payload;
      })
      .addCase(jobsConstants.SHOW_FORM, (state, action) => {
        state.showForm = action.payload;
      })
      .addCase(jobsConstants.UPDATE_JOBS, (state, action) => {
        state.jobs = action.payload;
      })
      .addCase(jobsConstants.UPDATE_REQUEST_JOBS, (state, action) => {
        state.jobsRequest = action.payload;
      })
      .addCase(jobsConstants.UPDATE_REQUEST_DETAIL_JOBS, (state, action) => {
        state.detailJob = action.payload;
      })
      .addCase(jobsConstants.UPDATE_COMPANIES, (state, action) => {
        state.companies = action.payload;
      })
      .addCase(jobsConstants.UPDATE_COMPANIES_DETAIL, (state, action) => {
        state.companyDetail = action.payload;
      })
      .addCase(jobsConstants.UPDATE_COMPANIES_DETAIL_JOBS, (state, action) => {
        state.companyDetailJobs = action.payload;
      })
      .addCase(jobsConstants.UPDATE_APPLICANTS, (state, action) => {
        state.detailApplicant = null;
        state.applicants = action.payload;
      })
      .addCase(jobsConstants.UPDATE_APPLICANTIONS, (state, action) => {
        state.applications = action.payload;
      })
      .addCase(jobsConstants.SUCCESS, (state, action) => {
        state.success = action.payload;
      })
      .addCase(userConstants.LOGOUT, () => initialState);
  },
});

export default jobsSlice.reducer;
